import { Box, Typography } from "@mui/material";
import type { ColumnDef } from "@tanstack/react-table";
import React from "react";

import ChannelsTableView from "@/components/MiddleTableNavigation/ChannelsTableView";
import { useChannelsTable } from "@/components/MiddleTableNavigation/useChannelsTable";
import StatusLight from "@/components/StatusLight";
import type { NonAliasChannelRow } from "@/models/repositories/Feed";
import type { DataTableFeatures } from "@/ui/dataTableFeatures";
import BellIconOn from "../Icons/BellIconOn.tsx";

const columns: ColumnDef<DataTableFeatures, NonAliasChannelRow>[] = [
  {
    accessorKey: "title",
    header: "Channel",
    cell: ({ row }) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: row.original.unread ? 600 : 400,
            color: "white",
          }}
        >
          {row.original.title}
        </Typography>
        {row.original.unread && <StatusLight color="#ef4444" size={8} />}
        {row.original.subscribed && (
          <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }} aria-label="Subscribed to notifications">
            <BellIconOn fontSize="18" />
          </Box>
        )}
      </Box>
    ),
    meta: { flex: 1 },
    minSize: 150,
    enableSorting: false,
    enableGlobalFilter: true,
  },
];

export default React.memo(function ChannelsTable() {
  const state = useChannelsTable(columns);
  return <ChannelsTableView {...state} />;
});
